import { useMemo } from 'react';
import { getMaxDate } from '../lib/getMaxDate';
import { useSearchFormFieldValue } from './useSearchFormFieldValue';

export const useGetMaxDate = () => {
    const deal = useSearchFormFieldValue('deal') || undefined;
    const pickUpDate = useSearchFormFieldValue('pickUpDate') || undefined;
    return useMemo(() => getMaxDate({ deal, pickUpDate }), [deal, pickUpDate]);
};
